import { Flex } from "@chakra-ui/react";
import SkeletonBox from "./SkeletonBox";

const SkeletonTable: React.FC = () => (
  <Flex direction="column" gap={2}>
    <SkeletonBox h="40px" borderRadius="md" />
    <SkeletonBox h="40px" borderRadius="md" />
    <SkeletonBox h="40px" borderRadius="md" />
  </Flex>
);

export default SkeletonTable;
